import { render } from "./Perguntas.vue?vue&type=template&id=325130fd"
import script from "./Perguntas.vue?vue&type=script&lang=js"
export * from "./Perguntas.vue?vue&type=script&lang=js"

import "./Perguntas.vue?vue&type=style&index=0&id=325130fd&lang=css"

import exportComponent from "F:\\Projetos-Lefisc\\front-end\\front_retfont\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__